// @ts-nocheck
import type { Question } from '../types';

export const speedLimitsQuestions: Question[] = [
  {
    id: 'q-sl-1',
    topic: 'General',
    question: 'What is the maximum speed limit on a motorway in the Netherlands during normal conditions?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/speed-limits/speed-1-motorway-100-good-weather.jpg',
    options: [
      { id: 'q-sl-1o1', text: '80 km/h' },
      { id: 'q-sl-1o2', text: '100 km/h' },
      { id: 'q-sl-1o3', text: '120 km/h' },
      { id: 'q-sl-1o4', text: '130 km/h' }
    ],
    answerId: 'q-sl-1o2',
    explanation: 'Since March 2020, the standard maximum speed on Dutch motorways is 100 km/h. This applies day and night. On specific sections 130 km/h is permitted between 19:00 and 06:00 where posted. (RVV 1990 art. 98)',
    subject: 'Speed Limits'
  },
  {
    id: 'q-sl-2',
    topic: 'General',
    question: 'At night on a Dutch motorway, you see a speed limit sign showing 100 km/h. What maximum speed applies?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/speed-limits/speed-8-motorway-night-100kmh.jpg',
    options: [
      { id: 'q-sl-2o1', text: '80 km/h — motorway limits are reduced at night' },
      { id: 'q-sl-2o2', text: '100 km/h — the posted sign is mandatory regardless of time of day' },
      { id: 'q-sl-2o3', text: '120 km/h — a higher night-time limit automatically applies on motorways' },
      { id: 'q-sl-2o4', text: '130 km/h — all Dutch motorways allow 130 km/h at night' }
    ],
    answerId: 'q-sl-2o2',
    explanation: 'Posted speed limit signs are mandatory at all times, day and night. If a sign shows 100 km/h, that is the maximum you may drive. On specific motorway sections a 130 km/h limit is permitted between 19:00 and 06:00 — but only where that sign is posted. (RVV 1990 art. 98)',
    subject: 'Speed Limits'
  },
  {
    id: 'q-sl-3',
    topic: 'General',
    question: 'What is the typical speed limit in urban residential areas?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/speed-limits/speed-3-urban-50kmh.jpg',
    options: [
      { id: 'q-sl-3o1', text: '30 km/h' },
      { id: 'q-sl-3o2', text: '50 km/h' },
      { id: 'q-sl-3o3', text: '60 km/h' },
      { id: 'q-sl-3o4', text: '80 km/h' }
    ],
    answerId: 'q-sl-3o2',
    explanation: 'In urban residential areas, the typical speed limit is 50 km/h unless otherwise posted. Some areas may have lower limits (30 km/h zones). Always follow posted speed signs. (RVV 1990 art. 98)',
    subject: 'Speed Limits'
  },
  {
    id: 'q-sl-4',
    topic: 'General',
    question: 'What is the speed limit in a Zone 30 (30 km/h residential area)?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/speed-limits/speed-4-30kmh-zone-entry.jpg',
    options: [
      { id: 'q-sl-4o1', text: '20 km/h' },
      { id: 'q-sl-4o2', text: '30 km/h' },
      { id: 'q-sl-4o3', text: '40 km/h' },
      { id: 'q-sl-4o4', text: '50 km/h' }
    ],
    answerId: 'q-sl-4o2',
    explanation: 'Zone 30 areas have a mandatory speed limit of 30 km/h. These zones prioritize pedestrian and cyclist safety in residential neighborhoods. You must comply with the speed limit even if the road appears empty. (RVV 1990 art. 98)',
    subject: 'Speed Limits'
  },
  {
    id: 'q-sl-5',
    topic: 'General',
    question: 'What is the typical speed limit on rural roads in the Netherlands?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/speed-limits/speed-5-rural-80kmh.jpg',
    options: [
      { id: 'q-sl-5o1', text: '60 km/h' },
      { id: 'q-sl-5o2', text: '70 km/h' },
      { id: 'q-sl-5o3', text: '80 km/h' },
      { id: 'q-sl-5o4', text: '100 km/h' }
    ],
    answerId: 'q-sl-5o3',
    explanation: 'The typical speed limit on rural roads in the Netherlands is 80 km/h unless otherwise posted. Rural roads often have lower visibility and unpredictable hazards, so maintain safe speeds. (RVV 1990 art. 98)',
    subject: 'Speed Limits'
  },
  {
    id: 'q-sl-6',
    topic: 'General',
    question: 'When transitioning from a motorway to rural or urban roads, what should you do with your speed?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/speed-limits/speed-6-rural-urban-transition.jpg',
    options: [
      { id: 'q-sl-6o1', text: 'Maintain motorway speed until seeing new speed signs' },
      { id: 'q-sl-6o2', text: 'Gradually reduce speed as you approach the new road type and follow posted speed limits' },
      { id: 'q-sl-6o3', text: 'Immediately decelerate to minimum speed' },
      { id: 'q-sl-6o4', text: 'Speed does not need to change' }
    ],
    answerId: 'q-sl-6o2',
    explanation: 'When transitioning from motorways to other road types, gradually reduce your speed and follow the posted speed limits for that road. Abrupt speed changes are dangerous and inefficient. (RVV 1990 art. 98)',
    subject: 'Speed Limits'
  },
  {
    id: 'q-sl-7',
    topic: 'General',
    question: 'What does a white circular sign with a red border and a speed number indicate?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/speed-limits/speed-7-speed-sign-recognition.jpg',
    options: [
      { id: 'q-sl-7o1', text: 'An optional suggested speed' },
      { id: 'q-sl-7o2', text: 'A mandatory maximum speed that must be obeyed' },
      { id: 'q-sl-7o3', text: 'The average traffic speed in that area' },
      { id: 'q-sl-7o4', text: 'The speed limit for heavy vehicles only' }
    ],
    answerId: 'q-sl-7o2',
    explanation: 'A white circular sign with a red border (RVV bord A1) indicates a mandatory maximum speed limit. All drivers must comply. A white rectangular sign (bord A4) indicates only an advisory/recommended speed. (RVV 1990 art. 98)',
    subject: 'Speed Limits'
  },
  {
    id: 'q-sl-8',
    topic: 'General',
    question: 'When driving conditions are poor (rain, snow, fog), what should you do regarding speed limits?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/speed-limits/speed-2-motorway-100-bad-weather.jpg',
    options: [
      { id: 'q-sl-8o1', text: 'Maintain the posted speed limit regardless of conditions' },
      { id: 'q-sl-8o2', text: 'Speed limits are reduced automatically in bad weather' },
      { id: 'q-sl-8o3', text: 'Reduce your speed below the posted limit to suit the conditions' },
      { id: 'q-sl-8o4', text: 'Only reduce speed on motorways, not on other roads' }
    ],
    answerId: 'q-sl-8o3',
    explanation: 'You must adapt your speed to suit the road conditions. In rain, snow, or fog, reduce your speed below the posted limit to maintain safe braking distance and control. Safety is more important than reaching the posted speed. (RVV 1990 art. 10)',
    subject: 'Speed Limits'
  },
  {
    id: 'q-sl-9',
    topic: 'General',
    question: 'Are temporary variable speed limits on motorways mandatory?',
    options: [
      { id: 'q-sl-9o1', text: 'No, they are suggestions only' },
      { id: 'q-sl-9o2', text: 'Yes, they are mandatory and must be obeyed' },
      { id: 'q-sl-9o3', text: 'Only for trucks, not for cars' },
      { id: 'q-sl-9o4', text: 'Only during nighttime' }
    ],
    answerId: 'q-sl-9o2',
    explanation: 'Variable speed limits displayed on motorway gantry signs are mandatory and must be obeyed by all drivers. These are used to manage traffic flow and improve safety in congestion or hazardous conditions. (RVV 1990 art. 82)',
    subject: 'Speed Limits'
  },
  {
    id: 'q-sl-10',
    topic: 'General',
    question: 'What is the penalty for exceeding the speed limit in the Netherlands?',
    options: [
      { id: 'q-sl-10o1', text: 'Warning only for first offense' },
      { id: 'q-sl-10o2', text: 'Fine, and potentially demerit points or license suspension' },
      { id: 'q-sl-10o3', text: 'No penalty if only exceeding by 5 km/h' },
      { id: 'q-sl-10o4', text: 'Vehicle confiscation immediately' }
    ],
    answerId: 'q-sl-10o2',
    explanation: 'Exceeding speed limits results in fines and may result in demerit points being added to your driving record. Serious or repeated offenses can lead to license suspension or other penalties. Speed limits save lives. (RVV 1990 art. 98)',
    subject: 'Speed Limits'
  }
];
